import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { productImage } from '../data/content';
export function FinalCTA() {
  return <section className="bg-brand-black px-4 py-6 text-center text-white sm:px-6" aria-labelledby="final-heading" data-id="element-42" data-mp="c6iuzupli37o">
      <h2 id="final-heading" className="mb-2 text-2xl leading-none text-white sm:text-4xl" data-id="element-43" data-mp="8448n0mpwlbn">
        ONE LAST CHANCE
      </h2>
      <p className="mx-auto mb-2 max-w-xl text-xs leading-snug text-white/80 sm:text-sm" data-id="element-44" data-mp="m3416jdcpkd3">
        Your athletes deserve more than sessions planned at the last minute. Stop spending hours
        creating workouts, searching through scattered resources, building new drills, organizing
        combinations, preparing conditioning sessions, and reinventing every class. Instead, coach
        with confidence using one complete professional operating system that gives you everything
        already planned, organized, and ready to use.
      </p>
      <p className="mx-auto mb-3 max-w-xl font-heading text-xs font-semibold leading-snug text-white sm:text-sm" data-id="element-45" data-mp="2c56e4c4hyjn3">
        Spend less time preparing. Spend more time coaching. Help every athlete improve technique,
        conditioning, confidence, and overall boxing performance with a system built specifically for
        professional boxing coaches.
      </p>
      <a href="#pricing" className="mb-3 block" data-id="element-46" data-mp="2qzuh9jmfd5zj">
        <img src={productImage} alt="Boxing Coach Pro complete 6-in-1 system" className="mx-auto w-full max-w-[190px] rounded-xl object-contain shadow-[0_16px_36px_rgba(0,0,0,0.5)] transition-transform duration-200 hover:scale-[1.02]" data-id="element-47" data-mp="2v4akfd4nlzb2" />
      </a>
      <div className="mx-auto mb-3 max-w-sm rounded-xl border border-brand-gold/50 bg-white/5 p-3" data-id="element-48" data-mp="39sye1duxvyyd">
        <p className="font-heading text-xs font-semibold" data-id="element-49" data-mp="3es1iaw33i15a">
          🥊 BOXING COACH PRO™
          <br data-id="element-50" data-mp="3istrjpbyw61k" />
          Complete 6-in-1 Operating System + 5 Premium Bonuses
        </p>
        <p className="mt-1 text-xs text-white/60 line-through" data-id="element-51" data-mp="1joczyjhcj9z6">Regular Price: $97</p>
        <p className="text-2xl leading-none text-brand-gold" data-id="element-52" data-mp="1jlz4i9ir7vr3">TODAY ONLY: $27 USD</p>
      </div>
      <div className="mx-auto mb-3 max-w-md" data-id="element-53" data-mp="1en5tcnqxwgu3">
        <CTAButton data-id="element-54" data-mp="1sgwyzl1jvgkj">🚀 YES! I WANT MY BOXING COACH PRO™ SYSTEM</CTAButton>
      </div>
      <div className="flex flex-col items-center justify-center gap-1 font-heading text-[10px] font-semibold text-white/85 sm:flex-row sm:gap-3" data-id="element-55" data-mp="1npf0d3n01s2q">
        <span className="flex items-center gap-1" data-id="element-56" data-mp="22d01is0bdh80">
          <ZapIcon className="h-3.5 w-3.5 text-brand-gold" aria-hidden="true" data-id="element-57" data-mp="1xg9m86wc2pnn" />
          Immediate Access • Delivered Instantly by Email
        </span>
        <span data-id="element-58" data-mp="2beq2aog35sig">⭐ 4.9/5 — Verified Coach Reviews</span>
        <span className="flex items-center gap-1" data-id="element-59" data-mp="27do327m65ggh">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-gold" aria-hidden="true" data-id="element-60" data-mp="27btg6nrc7e9r" />
          7-Day Money-Back Guarantee — Zero Risk
        </span>
      </div>
    </section>;
}